export default "__VITE_ASSET__e456cab3__"